import React from "react";
import { Container, Typography, Box, Paper, Link } from "@mui/material";

const bulletListSx = {
    "& ul": {
        pl: 3,
        color: "#000", // text color black
        mb: 0,
        listStyleType: "disc",
    },
    "& ul li": {
        color: "#000", // text color black
        fontSize: "1rem",
        mb: 1,
        position: "relative",
        listStyleType: "disc",
    },
    "& ul li::marker": {
        color: "#0f63af", // bullet color
    },
};
const PrivacyPolicy = () => {
    return (
        <Box
            sx={{
                position: 'relative',
                minHeight: '100vh',
                width: '100%',
                overflow: 'hidden',
            }}
        >
            {/* Background Image */}
            <Box
                sx={{
                    position: 'fixed',
                    top: '60%',
                    left: '50%',
                    width: { xs: '80vw', md: '40vw' },
                    height: { xs: '80vw', md: '30vw' },
                    maxWidth: 600,
                    maxHeight: 600,
                    transform: 'translate(-50%, -50%)',
                    zIndex: 0,
                    pointerEvents: 'none',
                    opacity: 0.08,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <img
                    src="https://dprstorage.b-cdn.net/RW/RW%20LOGO.png"
                    alt="Background Logo"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        filter: 'blur(0.5px)',
                        userSelect: 'none',
                    }}
                />
            </Box>
            {/* Blurred Content */}
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 1, // Make sure this is above the background image
                }}
            >
                <Container maxWidth="lg">
                    <Box
                        sx={{
                            bgcolor: "rgba(15, 99, 165, 0.4)",
                            // backdropFilter: "blur(8px)",
                            WebkitBackdropFilter: "blur(3px)",
                            p: 4,
                            borderRadius: 3,
                            color: "#E0E0E0",
                            boxShadow: "0px 4px 20px rgba(255, 255, 255, 0.1)",
                            textAlign: "left",
                            mt: 16,
                            ...bulletListSx,
                        }}
                    >
                        <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", color: "#00" }}>
                            Privacy Policy
                        </Typography>
                        <Typography variant="body2">
                            At <Link href="https://rajivwilliams.com" target="_blank" rel="noopener noreferrer" color="#0f63a5" underline="always">
                                rajivwilliams.com
                            </Link>, your privacy is important to us. This Privacy Policy explains how we collect, use, store, and protect your personal information when you visit or interact with our website. By using this website, you agree to the terms outlined in this policy.
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#00" }}>
                            1. Information We Collect
                        </Typography>
                        <Typography variant="body2" component="div">
                            <ul>
                                <Typography variant="caption" sx={{fontWeight:800,mb:1}}>a. Personal Information (if submitted by you):</Typography>
                                <ul>
                                    <li>Name</li>
                                    <li>Email address</li>
                                    <li>Phone number</li>
                                    <li>Messages or inquiries submitted through contact forms</li>
                                </ul>


                                <Typography variant="caption" sx={{fontWeight:800,mb:1}}>b. Non-Personal Information (automatically collected):</Typography>
                                <ul>
                                    <li>Browser type and version</li>
                                    <li>IP address</li>
                                    <li>Device type</li>
                                    <li>Pages visited</li>
                                    <li>Referring site</li>
                                    <li>Time and date of visit</li>
                                </ul>

                                <li>
                                    This data helps us improve user experience, website performance, and security.
                                </li>
                            </ul>
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#00" }}>
                            2. How We Use Your Information
                        </Typography>
                        <Typography variant="body2" component="div">
                            <Typography variant="body2" paragraph>We may use your information for the following purposes:</Typography>
                            <ul>
                                <li>To respond to your inquiries or messages</li>
                                <li>To provide and improve the content and features of the website</li>
                                <li>To monitor website traffic and user behavior</li>
                                <li>To detect and prevent fraud or abuse</li>
                                <li>To comply with legal obligations</li>
                                <li>We do not sell, rent, or share your personal information with third parties for marketing purposes.</li>
                            </ul>
                        </Typography>
                            <Typography variant="body2" paragraph>We do not sell, rent, or share your personal information with third parties for marketing purposes.</Typography>


                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#00" }}>
                            3. Cookies
                        </Typography>
                        <Typography variant="body2" component="div">
                            <ul>
                                <li>We may use cookies and similar tracking technologies to enhance your browsing experience. Cookies are small text files stored on your device that help us analyze website traffic and usage patterns.</li>
                                <li>You can disable cookies through your browser settings, but doing so may limit some features of the website.</li>
                            </ul>
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#00" }}>
                            4. Third-Party Services
                        </Typography>
                        <Typography variant="body2" component="div">
                                <Typography variant="body2" paragraph>We may use third-party services such as:</Typography>
                            <ul>
                                <ul>
                                    <li>Google Analytics (for visitor tracking)</li>
                                    <li>Contact form services or plugins</li>
                                    <li>Social media plugins (e.g., Instagram, LinkedIn)</li>
                                </ul>
                            </ul>
                                <Typography variant="body2">These third-party providers may collect data according to their own privacy policies. We recommend reviewing their terms directly.</Typography>
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#00" }}>
                            5. Data Security
                        </Typography>
                        <Typography variant="body2" component="div">
                            <ul>
                                <li>We take appropriate technical and organizational measures to protect your data from unauthorized access, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</li>
                            </ul>
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#00" }}>
                            6. Your Rights
                        </Typography>
                        <Typography variant="body2" component="div">
                                <Typography variant="body2"  paragraph>Depending on your jurisdiction, you may have rights to:</Typography>
                            <ul>
                                <ul>
                                    <li>Access your personal information</li>
                                    <li>Request correction or deletion</li>
                                    <li>Withdraw consent</li>
                                    <li>Object to data processing</li>
                                </ul>
                            </ul>
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#00" }}>
                            7. Children’s Privacy
                        </Typography>
                        <Typography variant="body2" component="div">
                            <ul>
                                <li>This website is not intended for children under the age of 13. We do not knowingly collect personal information from children.</li>
                            </ul>
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 3, mb: 2, color: "#000" }}>
                            8. Changes to This Policy
                        </Typography>
                        <Typography variant="body2" component="div">
                            <ul>
                                <li>We may update this Privacy Policy periodically. Changes will be posted on this page with an updated “Effective Date.” Continued use of the website implies acceptance of the updated policy.</li>
                            </ul>
                        </Typography>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default PrivacyPolicy;
